import "./ChatInput.scss"
import { useEffect, useState } from "react";
import { IMessage, IChatOption, ChatTypeEnum } from "../../../../shared/models/chat_models";
import { reverseSearchMessageForRole } from "../../../../shared/utils/chat";
import { Button, Input, Radio } from "@mui/material";
import { ChatOptionEnum } from "../../chat-models";
import { BaseMapFilterEnum } from "../../../../shared/models/map_models";

interface IChatBoxProps {
    sendQuery: (query: string) => void
    loading: boolean,
    messages: Array<IMessage>,
    chatOptions: Array<IChatOption>
    chatOptionSelected: (option: IChatOption, radioIndex?: number) => void,
    selectedChatType: string 
}

const ChatInput = (props: IChatBoxProps) => {

    const [query, setQuery] = useState<string | null>(null)
    const [defaultQuery, setDefaultQuery] = useState<string>("")

    const dataQueryPlaceholder = "Give me all companies in Oklahoma"
    const conversationPlaceholder = "How many companies have milling machines in Oklahoma?"

    useEffect(() => {
        if(props.selectedChatType === ChatTypeEnum.QNA)
            setDefaultQuery(conversationPlaceholder)
        else if (props.selectedChatType === ChatTypeEnum.QUERY)
            setDefaultQuery(dataQueryPlaceholder)

    }, [props.selectedChatType])

    const sendQuery = () => {
        if(query) {
            props.sendQuery(query)
            setQuery(null)
        }
    }

    const formKeyDown = (e: React.KeyboardEvent) => {
        if(e.key === 'Enter'){
            e.preventDefault()
            sendQuery()
        } else if (e.key === 'ArrowUp'){
            const lastUserMessage = reverseSearchMessageForRole(props.messages, 'user')
            if (typeof(lastUserMessage?.content) === 'string')
                setQuery(lastUserMessage?.content)
            else
                setQuery(defaultQuery)
        }
    }

    return (
        <div className="chatbox-wrapper">
            <Input 
                disabled={props.loading}
                placeholder={defaultQuery} 
                value={query || ""}
                onChange={(e: any) => setQuery(e.target.value)}
                onKeyDown={formKeyDown}
            />
            <div className="chat-box-button-wrapper">
                {props.chatOptions.map((option, index) => {
                    return(
                        <>
                            {option.type === 'button' &&
                                <Button
                                    key={index}
                                    id={option.name}
                                    value={option.name}
                                    variant={option.checked ? "contained" : "outlined"}
                                    onClick={() => props.chatOptionSelected(option)}
                                >{option.name}</Button>
                            }
                            {option.type === BaseMapFilterEnum.RADIO && props.chatOptions.length > 1 &&
                                <div className="radio-option-wrapper" key={index}>
                                    {option.label}:
                                    {option.radioOptions?.map((radioOption, radioIndex) => {
                                        return (
                                            <div className="radio-button-wrapper" key={option.name + radioIndex}>
                                                <Radio 
                                                    name={option.name}
                                                    value={radioOption.value}
                                                    checked={option.name ===  ChatOptionEnum.CHAT_TYPE && 
                                                        props.selectedChatType === radioOption.value
                                                    }
                                                    onClick={() => props.chatOptionSelected(option, radioIndex)}
                                                />
                                                <span className="radio-button-label">{radioOption.label}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                        </>
                    )
                })}
            </div>
        </div>
    )
}

export default ChatInput